// extracted by mini-css-extract-plugin
export default {"panel":"wifi-zones-item_panel__Y-glu","name":"wifi-zones-item_name__VedtS","form":"wifi-zones-item_form__faLkL"};